import CommonUiModel from "../../common/commonUiModel";

const Role = new CommonUiModel({
    title:"SecurityRole",
    permissions: { add: false, edit: false, delete: false },
    linkColumn: "Name",
    defaultSort: "Name ASC",
    idProperty: 'RoleId',
    formTitle: 'Roles',
    gridTitle: 'Roles',
    module: "Role",
    showHistory: false,
    columns: [
        { field: 'RoleId', label: 'User Role', width: 150, required: true, type: 'select', lookup: 'SecurityRole', selectField: "RoleId", dataIndex: "Name" },
        { field: 'Name', label: 'Name', required: true, min: 1, max: 30, width: 150 }
    ]
});

export default Role;